import { asburyParkConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function AsburyParkPage() {
  return <CityPageTemplate config={asburyParkConfig} />;
}